import(/* webpackMode: "eager" */ "/vercel/path0/app/sign-up/[[...sign-up]]/page.tsx")